// const allowedExtention = ['__all', 'pdf', 'xlsx', 'txt', 'csv', 'html'];
const moment = require('moment-timezone');
let yesterday = moment()
	.tz('Asia/Kolkata')
	.startOf('day')
	.subtract(1, 'day')
	.toISOString();

let momentToday = moment()
	.tz('Asia/Kolkata')
	.startOf('day');
let today = momentToday.toISOString();

module.exports = [
	{
		name: "Fetch Today's Emails",
		method: 'POST',
		url: '/RunUtilities/v0.1/fetch-todays-emails',
		body: {
			startDate: yesterday,
			endDate: today,
			mailQuery:
				'from:rakesh.solanki@alkem.com // gmail filter example or ["FROM", "dhamapurkar54@gmail.com"] imap filter example or // (from/emailAddress/address) eq \'dhamapurkar54@gmail.com\' for microsoft graph api',
		},
	},
	{
		name: 'Delete File Meta',
		method: 'GET',
		url: '/Utility/v0.1/delete-file-meta',
		queryParams: [
			{
				key: 'id',
				defaultValue: null,
				dataType: 'string',
				type: 'input',
				allowedValues: '',
				required: true,
			},
			{
				key: 'deletematching',
				defaultValue: 'false',
				dataType: 'string',
				type: 'dropDown',
				allowedValues: ['false', 'true'],
				required: false,
			},
		],
	},
	{
		name: 'Run Discovery Mode',
		method: 'GET',
		url: '/RunUtilities/v0.1/alldiscoveryMode',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
		],
	},
	{
		name: 'Run Discovery Mode V2',
		method: 'GET',
		url: '/RunUtilities/v0.2/discoveryMode',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
		],
	},
	{
		name: 'Run Discovery Mode V3',
		method: 'GET',
		url: '/RunUtilities/v3.0/discoveryMode',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
		],
	},
	{
		name: 'Remap Files',
		method: 'GET',
		url: '/RunUtilities/v0.1/remap-files',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
		],
	},
	{
		name: 'Only Extract',
		method: 'GET',
		url: '/RunUtilities/v0.1/onlyExtract',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: false,
			},
		],
	},
	{
		name: 'Pull Field Files',
		method: 'POST',
		url: '/Test/v0.1/fetchFieldFilesAndProcess',
		bodyPreparer: 'fieldFileIds',
		body: {
			startDate: yesterday,
			endDate: today,
			// when non-empty, startDate/endDate are not sent
			fieldFileIds: [],
		},
	},
	{
		name: 'Convert Files using PDF tables',
		method: 'GET',
		url: '/Test/v0.1/pdf-tables-convert',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Split Multipage PDFs',
		method: 'GET',
		url: '/Test/v0.1/process-multi-pdf',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Process Single Multi Page Excel',
		method: 'POST',
		url: '/Utility/v0.1/process-single-multi-worksheet-excel',
		body: {
			uuid: '44c1a790-c65f-4e92-afb8-5ad379936ad0',
		},
	},
	{
		name: 'Convert Multipage Pdf to XLSX [PYTHON_SCRIPT_CONVERTABLE]',
		method: 'GET',
		url: '/Converters/v0.1/convert/pdf-multi-page-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert Multiline Pdf to XLSX [PYTHON_SCRIPT_CONVERTABLE]',
		method: 'GET',
		url: '/Converters/v0.1/convert/pdf-multi-line-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name:
			"Convert PDF table convertable pdf's to XLSX [PYTHON_SCRIPT_CONVERTABLE]",
		method: 'GET',
		url: '/Converters/v0.1/convert/pdf-table-convertable-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert the [PYTHON_SCRIPT_CONVERTABLE] remark files',
		method: 'GET',
		url: '/Converters/v0.1/convert/python-script-convertable-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert the [PYTHON_SCRIPT_DELIMITER_CONVERTABLE] remark files',
		method: 'GET',
		url: '/Converters/v0.1/convert/python-script-delimiter-convertable-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert the [PDF_ML_MODEL_CONVERTABLE] remark files',
		method: 'GET',
		url: '/Converters/v0.1/convert/pdf-ml-model-convertable',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert PDF Gemini to XLSX',
		method: 'GET',
		url: '/Converters/v0.1/convert/pdf-gemini-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert the [PDF_ML_MODEL_HEADERS_CONVERTABLE] remark files',
		method: 'GET',
		url: '/Converters/v0.1/convert/pdf-ml-model-headers-convertable',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert the [XLSX_FILL_MISSING_CONVERTABLE] remark files',
		method: 'GET',
		url: '/Converters/v0.1/convert/xlsx-fill-missing-convertable',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Convert the [XLS_TO_XLSX_CONVERTABLE] remark files',
		method: 'GET',
		url: '/Converters/v0.1/convert/python-script-convertable-xls-to-xlsx',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Revert Reintroduction',
		method: 'PUT',
		url: '/Converters/v0.1/revert-reintroduction-and-map-file-manually',
		body: {
			uuid: '_uuid_here_',
			extractManually: true,
		},
	},
	{
		name: 'Revert To Meta Not Found',
		method: 'PUT',
		url: '/Converters/v0.1/revert-to-meta-not-found',
		body: {
			uuids: ['_uuid_here_'],
		},
	},
	{
		name: 'Revert To Stockist Unmapped',
		method: 'PUT',
		url: '/Converters/v0.1/revert-to-stockist-unmapped',
		body: {
			uuids: ['_uuid_here_'],
		},
	},
	{
		name: 'Push Product Mapping',
		method: 'GET',
		url: '/AdminUtility/v0.1/push-product-mapping',
		queryParams: [
			{
				key: 'date',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Data Log Custom Month',
		method: 'GET',
		url: '/Test/v0.1/data-report-custom-month',
		queryParams: [
			{
				key: 'month',
				defaultValue: momentToday.format('MMMM').toUpperCase(),
				dataType: 'string',
				type: 'dropDown',
				allowedValues: moment.months().map(e => e.toUpperCase()),
				required: true,
			},
			{
				key: 'year',
				defaultValue: momentToday.format('YYYY'),
				dataType: 'string',
				type: 'input',
				allowedValues: null,
				required: true,
			},
		],
	},	
	{
		name: 'Mail Log Custom Month',
		method: 'GET',
		url: '/Test/v0.1/mail-report-custom-month',
		queryParams: [
			{
				key: 'month',
				defaultValue: momentToday.format('MMMM').toUpperCase(),
				dataType: 'string',
				type: 'dropDown',
				allowedValues: moment.months().map(e => e.toUpperCase()),
				required: true,
			},
			{
				key: 'year',
				defaultValue: momentToday.format('YYYY'),
				dataType: 'string',
				type: 'input',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Data Log And Mail Log Custom Month',
		method: 'GET',
		url: '/Test/v0.1/data-log-mail-log-custom-month',
		queryParams: [
			{
				key: 'month',
				defaultValue: momentToday.format('MMMM').toUpperCase(),
				dataType: 'string',
				type: 'dropDown',
				allowedValues: moment.months().map(e => e.toUpperCase()),
				required: true,
			},
			{
				key: 'year',
				defaultValue: momentToday.format('YYYY'),
				dataType: 'string',
				type: 'input',
				allowedValues: null,
				required: true,
			},
		],
	},
	{
		name: 'Auto Extract Excel Files',
		method: 'GET',
		url: '/Test/v0.1/auto-extract-excel-files',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
	// {
	// 	name: 'Discovery Mode',
	// 	method: 'GET',
	// 	url: '/RunUtilities/v0.1/discoveryMode',
	// 	queryParams: [
	// 		{
	// 			key: 'ext',
	// 			defaultValue: '__all',
	// 			dataType: 'string',
	// 			type: 'dropDown',
	// 			allowedValues: allowedExtention,
	// 			required: true,
	// 		},
	// 	],
	// },
	// {
	// 	name: 'Discovery Mode All',
	// 	method: 'GET',
	// 	url: '/RunUtilities/v0.1/alldiscoveryMode',
	// 	queryParams: [
	// 		{
	// 			key: 'ext',
	// 			defaultValue: '__all',
	// 			dataType: 'string',
	// 			type: 'dropDown',
	// 			allowedValues: allowedExtention,
	// 			required: true,
	// 		},
	// 	],
	// },
	// {
	// 	name: 'Reject Discovery',
	// 	method: 'GET',
	// 	url: '/RunUtilities/v0.1/rejectDiscovery',
	// 	queryParams: [
	// 		{
	// 			key: 'ext',
	// 			defaultValue: '__all',
	// 			dataType: 'string',
	// 			type: 'dropDown',
	// 			allowedValues: allowedExtention,
	// 			required: true,
	// 		},
	// 	],
	// },
	// {
	// 	name: 'Reject Discovery Mode All',
	// 	method: 'GET',
	// 	url: '/RunUtilities/v0.1/rejectDiscoveryAll',
	// 	queryParams: [
	// 		{
	// 			key: 'ext',
	// 			defaultValue: '__all',
	// 			dataType: 'string',
	// 			type: 'dropDown',
	// 			allowedValues: allowedExtention,
	// 			required: true,
	// 		},
	// 	],
	// },
	// {
	// 	name: 'Send Reject Mails',
	// 	method: 'GET',
	// 	url: '/RunUtilities/v0.1/sendRejectMails',
	// },
	// {
	// 	name: 'Send Reminder Mails',
	// 	method: 'GET',
	// 	url: '/RunUtilities/v0.1/sendReminderEmails',
	// },
	// {
	// 	name: 'Extract Tables From Images And ReIntroduce',
	// 	method: 'GET',
	// 	url: '/Test/v0.1/extractTablesFromImagesAndReIntroduce',
	// 	queryParams: [
	// 		{
	// 			key: 'startDate',
	// 			defaultValue: '2019-12-18T18:30:00.000Z',
	// 			dataType: 'string',
	// 			type: 'date',
	// 			allowedValues: null,
	// 			required: true,
	// 		},
	// 		{
	// 			key: 'endDate',
	// 			defaultValue: '2019-12-19T18:30:00.000Z',
	// 			dataType: 'string',
	// 			type: 'date',
	// 			allowedValues: null,
	// 			required: true,
	// 		},
	// 	],
	// },
	// {
	// 	name: 'Send Email to Stockist',
	// 	method: 'POST',
	// 	url: '/RunUtilities/v0.1/send-email-to-stockist',
	// 	body: {
	// 		collectionName: 'stockist_meta',
	// 		aggregateFilter: [
	// 			{
	// 				$match: { _valid_email: true },
	// 			},
	// 			{
	// 				$group: {
	// 					_id: {
	// 						stockist_code: '$stockist_code',
	// 						email: '$email',
	// 					},
	// 				},
	// 			},
	// 			{
	// 				$replaceRoot: { newRoot: '$_id' },
	// 			},
	// 			{
	// 				$lookup: {
	// 					from: 'stockist_meta',
	// 					localField: 'stockist_code',
	// 					foreignField: 'stockist_code',
	// 					as: 'name',
	// 				},
	// 			},
	// 			{
	// 				$addFields: {
	// 					name: { $arrayElemAt: ['$name', 0] },
	// 				},
	// 			},
	// 			{
	// 				$addFields: {
	// 					name: '$name.name',
	// 				},
	// 			},
	// 		],
	// 		subject:
	// 			'Sales and stock statement reminder for the month of NOVEMBER-2019',
	// 		template:
	// 			'Dear ${this.name},\n\nPlease share your sales and stock statement for the month of ${this.month} for all Divisions. We appreciate your continued support. \n\n****Note****\nPlease take care of the below points before sending the stock statement\n\t1. Statements should atleast include "Opening", "Closing" "Purchase" and "Sales" quantities.\n\t2. Statements only in PDF, XLS, HTML, TXT, CSV are accepted.\n\t3. Do not send Sales register and purchase order statement.\n\t5. Do not send XLS file having multiple stockist data in different/same sheet.\n\t6. Send the stock statement in proper file format to ssales@alkem.com.\n\n****Note - Please do not reply to this mail, Ignore if aldready sent****\n\nRegards,\nTeam Alkem',
	// 		templateVariables: {
	// 			month: 'NOVEMBER-2019',
	// 		},
	// 	},
	// },
	{
		name: 'Run AI Stockist Mapping',
		method: 'GET',
		url: '/Stockist/v0.1/run-ai-stockist-mapping',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'reRun',
				defaultValue: 'false',
				dataType: 'string',
				type: 'dropDown',
				allowedValues: ['true', 'false'],
				required: false,
			},
		],
	},
	{
		name: 'Run Auto Map Stockist From AI Prediction',
		method: 'GET',
		url: '/Stockist/v0.1/auto-map-stockist-from-ai-prediction',
		queryParams: [
			{
				key: 'startDate',
				defaultValue: yesterday,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
			{
				key: 'endDate',
				defaultValue: today,
				dataType: 'string',
				type: 'date',
				allowedValues: null,
				required: true,
			},
		],
	},
];
